import { render } from "./NotAllow.vue?vue&type=template&id=78ffcc76&scoped=true"
import script from "./NotAllow.vue?vue&type=script&lang=js"
export * from "./NotAllow.vue?vue&type=script&lang=js"

import "./NotAllow.vue?vue&type=style&index=0&id=78ffcc76&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ffcc76"]])

export default __exports__